import { getCourseById, orUndefined } from '@lms/api-client/backend';
import { LoaderCircleIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import Player from '@/features/scormplayer/components/player';
import { NotFound } from '@/routes/not-found';

export function CoursePreview() {
  const { courseId } = useParams<{ courseId: string }>();
  const id = Number.parseInt(courseId ?? '', 10);

  const { data: course, isLoading } = useSWR(
    Number.isNaN(id) ? null : ['course', id],
    () => orUndefined(getCourseById(id)),
  );

  if (isLoading) {
    return (
      <div className="flex h-dvh items-center justify-center bg-white">
        <LoaderCircleIcon className="animate-spin" />
      </div>
    );
  }

  if (course === undefined) {
    return <NotFound />;
  }

  return <Player course={course} />;
}
